const COORDINATE_PAIR_PATTERN = /-?\d{1,3}(?:\.\d+)?\s*,\s*-?\d{1,3}(?:\.\d+)?/;
const STREET_ADDRESS_PATTERN = /^\s*\d{1,6}\s+[\w .'-]+?\s+(?:st|street|ave|avenue|rd|road|blvd|boulevard|dr|drive|ln|lane|ct|court|way|pl|place|terrace|ter|circle|cir|pkwy|parkway|hwy|highway)\b/i;

export const normalizePublicLocationLabel = (label) => {
  return String(label || '').replace(/\s+/g, ' ').trim();
};

export const getPublicLocationLabelError = (label) => {
  const normalizedLabel = normalizePublicLocationLabel(label);

  if (!normalizedLabel) {
    return 'Add a simple destination label';
  }

  if (normalizedLabel.length > 40) {
    return 'Use a shorter destination label';
  }

  if (COORDINATE_PAIR_PATTERN.test(normalizedLabel)) {
    return 'Use a label, not GPS coordinates';
  }

  if (STREET_ADDRESS_PATTERN.test(normalizedLabel)) {
    return 'Use a label like "Gym," not a street address';
  }

  return '';
};

export const getSafePlaceNameSuggestion = (place) => {
  const placeName = normalizePublicLocationLabel(place?.name);
  const formattedAddress = normalizePublicLocationLabel(place?.formatted_address);

  if (!placeName || placeName === formattedAddress || getPublicLocationLabelError(placeName)) {
    return '';
  }

  return placeName;
};
